import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import { Icon } from 'react-icons-kit';
import { starFull } from 'react-icons-kit/icomoon/starFull';
import Masonry from 'react-masonry-component';
import Box from 'common/components/Box';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Container from 'common/components/UI/Container';
import { SectionHeader } from '../appCreative.style';
import Button from 'common/components/Button';
import { ButtonWrapper } from '../../Portfolio/portfolio.style';

import SectionWrapper, {
  TestimonialWrapper,
  TestimonialItem,
  TestimonialItemInner,
  TestimonialHead,
  AuthorImage,
} from './testimonial.style';

const masonryOptions = {
  originTop: true,
};

const TestimonialSection = () => {
  const data = useStaticQuery(graphql`
    query {
      portfolioJson {
        testimonial {
          title
          slogan
          reviews {
            id
            description
            avatar {
              publicURL
            }
            name
            designation
            twitterProfile
          }
        }
      }
    }
  `);

  const { slogan, title, reviews } = data.portfolioJson.testimonial;
  return (
    <SectionWrapper id="testimonial">
      <Container>
        <SectionHeader>
          <Heading content={title} />
          <Text content={slogan} />
        </SectionHeader>
        <TestimonialWrapper>
          <Masonry className="masonryGrid" options={masonryOptions}>
            {reviews.map((item) => (
              <TestimonialItem key={`testimonial-item-${item.id}`}>
                <TestimonialItemInner>
                  <TestimonialHead>
                    <AuthorImage>
                      <Image alt="Upwork" src={item.avatar.publicURL} alt={item.name} />
                    </AuthorImage>
                    <Box className="nameWrapper">
                      <Heading as="h3" content={item.name} />
                      <Text content={item.designation} />
                    </Box>
                    <Link to="/upwork" >
                      <Icon icon={starFull} size={15} alt="upwork-star" />
                      <Icon icon={starFull} size={15} alt="upwork-star" />
                      <Icon icon={starFull} size={15} alt="upwork-star" />
                      <Icon icon={starFull} size={15} alt="upwork-star" />
                      <Icon icon={starFull} size={15} alt="upwork-star" />
                    </Link>
                  </TestimonialHead>
                  <Text content={item.description} />
                </TestimonialItemInner>
              </TestimonialItem>
            ))}
          </Masonry>
          <Heading as="h3" className="heading_btn" content="Yup, all of them are real."/>
            <ButtonWrapper>
                <Button
                onClick={()=>{window.open("https://www.upwork.com/fl/ilija")}}
                role="link"
                title="Check them on Upwork™ 🦄"
                className="portfolio_button reusecore__button btn-text green"
              />
            </ButtonWrapper>
        </TestimonialWrapper>
      </Container>
    </SectionWrapper>
  );
};

export default TestimonialSection;
